import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

// eslint-disable-next-line
export const BlogPostTemplate = ({
  content,
  contentComponent,
  description,
  title,
  featuredimage,
  helmet,
}) => {
  const PostContent = contentComponent || Content;

  return (
    <section className="section section--gradient" style={{ minHeight: 'calc(100vh - 250px)' }}>
    <div className="section columns is-justify-content-center blog-post-page"> 
      {helmet || ""}
      
      <div className="column is-4"> 
        {/* Display featured image with natural aspect ratio */}
        {featuredimage && featuredimage.childImageSharp && (
          <div className="featured-image mb-5">
            <GatsbyImage
              image={featuredimage.childImageSharp.gatsbyImageData}
              alt={`featured image for ${title}`}
              style={{ width: '100%' }}
            />
          </div>
        )}
        <PostContent content={content} />
      </div>
      
      <div className="column is-4"> 
        <h1 className="title is-size-2 has-text-weight-bold is-uppercase">
          {title}
        </h1>
        <p>{description}</p>
      </div>
    </div>
    </section>
  );
};

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  featuredimage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  helmet: PropTypes.object,
};

const BlogPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <BlogPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        featuredimage={post.frontmatter.featuredimage}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        title={post.frontmatter.title}
      />
    </Layout>
  );
};

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default BlogPost;

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        description
        featuredimage {
          childImageSharp {
            gatsbyImageData(
              width: 1200  # Larger width but no height constraint
              quality: 100
              layout: CONSTRAINED
            )
          }
        }
      }
    }
  }
`;